export interface PricerErrorResponse {
  _kind: 'pricerError'
  error: string
  raw: unknown
  request: unknown
}

export function isPricerError(response: unknown): response is PricerErrorResponse {
  return typeof response === 'object' && response !== null
    && '_kind' in response && (response as PricerErrorResponse)._kind === 'pricerError'
}
